import { render, staticRenderFns } from "./MiniHeader.vue?vue&type=template&id=86fb3878&scoped=true&lang=pug&"
import script from "./MiniHeader.vue?vue&type=script&lang=js&"
export * from "./MiniHeader.vue?vue&type=script&lang=js&"
import style0 from "./MiniHeader.vue?vue&type=style&index=0&id=86fb3878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fb3878",
  null
  
)

export default component.exports